module.exports = __webpack_public_path__ + "img/heir.ca340e4d.svg";